var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 130.016H0V130.101H170V130.016Z",
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8948 132.185H51.0136V132.27H58.8948V132.185Z",
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.982 134.008H136.714V134.093H155.982V134.008Z",
    fill: "#DFDFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7926 134.008H14.5248V134.093H33.7926V134.008Z",
    fill: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.58 114.852H14.9294C14.4151 114.851 13.9222 114.646 13.5588 114.282C13.1955 113.918 12.9914 113.425 12.9914 112.911V20.6244C12.9959 20.113 13.2019 19.6241 13.5648 19.2638C13.9276 18.9035 14.418 18.7009 14.9294 18.7H80.58C81.0949 18.7 81.5887 18.9045 81.9528 19.2686C82.3169 19.6327 82.5214 20.1265 82.5214 20.6414V112.911C82.5214 113.425 82.3169 113.919 81.9528 114.283C81.5887 114.647 81.0949 114.852 80.58 114.852ZM14.9294 18.768C14.4376 18.7689 13.9663 18.9649 13.6189 19.3129C13.2715 19.661 13.0764 20.1326 13.0764 20.6244V112.911C13.0764 113.402 13.2715 113.874 13.6189 114.222C13.9663 114.57 14.4376 114.766 14.9294 114.767H80.58C81.0718 114.765 81.5429 114.569 81.8907 114.221C82.2384 113.874 82.4346 113.402 82.4364 112.911V20.6244C82.4346 20.1326 82.2384 19.6615 81.8907 19.3137C81.5429 18.966 81.0718 18.7698 80.58 18.768H14.9294Z",
    fill: "#DFDFDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.125 114.852H88.4714C87.9571 114.85 87.4643 114.645 87.1006 114.281C86.7369 113.918 86.5318 113.425 86.53 112.911V20.6244C86.5354 20.1127 86.7422 19.6238 87.1056 19.2636C87.469 18.9034 87.9597 18.7009 88.4714 18.7H154.125C154.636 18.7018 155.126 18.9048 155.488 19.265C155.85 19.6252 156.056 20.1136 156.06 20.6244V112.911C156.06 113.165 156.011 113.417 155.914 113.652C155.817 113.888 155.674 114.102 155.495 114.282C155.315 114.462 155.102 114.605 154.867 114.703C154.632 114.801 154.38 114.852 154.125 114.852ZM88.4714 18.768C87.9796 18.7698 87.5085 18.966 87.1607 19.3137C86.813 19.6615 86.6168 20.1326 86.615 20.6244V112.911C86.6168 113.402 86.813 113.874 87.1607 114.221C87.5085 114.569 87.9796 114.765 88.4714 114.767H154.125C154.617 114.765 155.088 114.569 155.436 114.221C155.784 113.874 155.98 113.402 155.982 112.911V20.6244C155.98 20.1326 155.784 19.6615 155.436 19.3137C155.088 18.966 154.617 18.7698 154.125 18.768H88.4714Z",
    fill: "#DFDFDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8308 31H66.1423C66.5177 30.9994 66.8896 31.0724 67.2366 31.2149C67.5836 31.3573 67.8988 31.5663 68.1643 31.83C68.4298 32.0937 68.6403 32.4068 68.7837 32.7514C68.9271 33.096 69.0006 33.4654 69 33.8383V143H26V33.8338C26.0011 33.0864 26.2991 32.3697 26.8291 31.8391C27.3591 31.3086 28.0784 31.007 28.8308 31Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38H31V50H36V38Z",
    fill: "#DFDFDF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38H59V50H64V38Z",
    fill: "#DFDFDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38H41V50H46V38Z",
    fill: "#DFDFDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55 38H50V50H55V38Z",
    fill: "#DFDFDF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3112 64.1886H34.102V73.559H38.3112V64.1886Z",
    fill: "#DFDFDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3292 64.1886H57.12V73.559H61.3292V64.1886Z",
    fill: "#DFDFDF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9816 64.1886H41.7724V73.559H45.9816V64.1886Z",
    fill: "#DFDFDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6554 64.1886H49.4462V73.559H53.6554V64.1886Z",
    fill: "#DFDFDF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3112 78.9786H34.102V88.349H38.3112V78.9786Z",
    fill: "#DFDFDF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3292 78.9786H57.12V88.349H61.3292V78.9786Z",
    fill: "#DFDFDF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9816 78.9786H41.7724V88.349H45.9816V78.9786Z",
    fill: "#DFDFDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6554 78.9786H49.4462V88.349H53.6554V78.9786Z",
    fill: "#DFDFDF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3112 93.772H34.102V103.142H38.3112V93.772Z",
    fill: "#DFDFDF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3292 93.772H57.12V103.142H61.3292V93.772Z",
    fill: "#DFDFDF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9816 93.772H41.7724V103.142H45.9816V93.772Z",
    fill: "#DFDFDF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6554 93.772H49.4462V103.142H53.6554V93.772Z",
    fill: "#DFDFDF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3112 108.562H34.102V117.932H38.3112V108.562Z",
    fill: "#DFDFDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3292 108.562H57.12V117.932H61.3292V108.562Z",
    fill: "#DFDFDF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9816 108.562H41.7724V117.932H45.9816V108.562Z",
    fill: "#DFDFDF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6554 108.562H49.4462V117.932H53.6554V108.562Z",
    fill: "#DFDFDF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.94 52.1152H154.217C154.685 52.1161 155.133 52.3023 155.464 52.633C155.795 52.9638 155.981 53.4121 155.982 53.8798V129.938H132.182V53.8832C132.182 53.4161 132.367 52.9679 132.696 52.6366C133.025 52.3054 133.472 52.1179 133.94 52.1152Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 56.7154H135.208V65.2324H139.033V56.7154Z",
    fill: "#DFDFDF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 56.7154H142.185V65.2324H146.01V56.7154Z",
    fill: "#DFDFDF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 56.7154H149.158V65.2324H152.983V56.7154Z",
    fill: "#DFDFDF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 70.1624H135.208V78.6794H139.033V70.1624Z",
    fill: "#DFDFDF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 70.1624H142.185V78.6794H146.01V70.1624Z",
    fill: "#DFDFDF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 70.1624H149.158V78.6794H152.983V70.1624Z",
    fill: "#DFDFDF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 83.6128H135.208V92.1298H139.033V83.6128Z",
    fill: "#DFDFDF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 83.6128H142.185V92.1298H146.01V83.6128Z",
    fill: "#DFDFDF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 83.6128H149.158V92.1298H152.983V83.6128Z",
    fill: "#DFDFDF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 97.0564H135.208V105.573H139.033V97.0564Z",
    fill: "#DFDFDF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 97.0564H142.185V105.573H146.01V97.0564Z",
    fill: "#DFDFDF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 97.0564H149.158V105.573H152.983V97.0564Z",
    fill: "#DFDFDF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.033 110.507H135.208V119.024H139.033V110.507Z",
    fill: "#DFDFDF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 110.507H142.185V119.024H146.01V110.507Z",
    fill: "#DFDFDF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M152.983 110.507H149.158V119.024H152.983V110.507Z",
    fill: "#DFDFDF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.184 13H124.812C125.657 13 126.468 13.347 127.066 13.9645C127.664 14.5821 128 15.4198 128 16.2932V143H80V16.2932C80 15.4205 80.3353 14.5836 80.9323 13.9661C81.5293 13.3487 82.3391 13.0012 83.184 13Z",
    fill: "#F4F4F4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 36.2338H88.1178V47.1342H93.0138V36.2338Z",
    fill: "#DFDFDF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 19.2338H88.1178V30.1342H93.0138V19.2338Z",
    fill: "#DFDFDF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 36.2338H114.896V47.1342H119.792V36.2338Z",
    fill: "#DFDFDF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 19.2338H114.896V30.1342H119.792V19.2338Z",
    fill: "#DFDFDF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 36.2338H97.0428V47.1342H101.939V36.2338Z",
    fill: "#DFDFDF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 19.2338H97.0428V30.1342H101.939V19.2338Z",
    fill: "#DFDFDF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 36.2338H105.971V47.1342H110.867V36.2338Z",
    fill: "#DFDFDF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 19.2338H105.971V30.1342H110.867V19.2338Z",
    fill: "#DFDFDF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 53.4446H88.1178V64.345H93.0138V53.4446Z",
    fill: "#DFDFDF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 53.4446H114.896V64.345H119.792V53.4446Z",
    fill: "#DFDFDF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 53.4446H97.0428V64.345H101.939V53.4446Z",
    fill: "#DFDFDF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 53.4446H105.971V64.345H110.867V53.4446Z",
    fill: "#DFDFDF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 70.6554H88.1178V81.5558H93.0138V70.6554Z",
    fill: "#DFDFDF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 70.6554H114.896V81.5558H119.792V70.6554Z",
    fill: "#DFDFDF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 70.6554H97.0428V81.5558H101.939V70.6554Z",
    fill: "#DFDFDF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 70.6554H105.971V81.5558H110.867V70.6554Z",
    fill: "#DFDFDF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 87.8628H88.1178V98.7632H93.0138V87.8628Z",
    fill: "#DFDFDF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 87.8628H114.896V98.7632H119.792V87.8628Z",
    fill: "#DFDFDF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 87.8628H97.0428V98.7632H101.939V87.8628Z",
    fill: "#DFDFDF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 87.8628H105.971V98.7632H110.867V87.8628Z",
    fill: "#DFDFDF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0138 105.07H88.1178V115.971H93.0138V105.07Z",
    fill: "#DFDFDF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M119.792 105.07H114.896V115.971H119.792V105.07Z",
    fill: "#DFDFDF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 105.07H97.0428V115.971H101.939V105.07Z",
    fill: "#DFDFDF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 105.07H105.971V115.971H110.867V105.07Z",
    fill: "#DFDFDF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9626 66.0178H64.039V129.941H84.9626V66.0178Z",
    fill: "#E6E6E6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M132.195 72.862H122.951V129.938H132.195V72.862Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3888 129.938H13.0764V103.251L31.3888 97.0564V129.938Z",
    fill: "#E6E6E6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M85 145.37C121.408 145.37 150.923 142.952 150.923 139.968C150.923 136.984 121.408 134.565 85 134.565C48.5919 134.565 19.0774 136.984 19.0774 139.968C19.0774 142.952 48.5919 145.37 85 145.37Z",
    fill: "#F5F5F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M101.211 118.633H95.4312C92.4222 118.633 89.9912 122.995 89.9912 128.377C89.9912 133.759 92.429 138.118 95.4312 138.118H101.211C104.22 138.118 106.651 133.756 106.651 128.377C106.651 122.998 104.22 118.633 101.211 118.633Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_2352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 118,
    width: 18,
    height: 21
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M101.211 118.633H95.4312C92.4222 118.633 89.9912 122.995 89.9912 128.377C89.9912 133.759 92.429 138.118 95.4312 138.118H101.211C104.22 138.118 106.651 133.756 106.651 128.377C106.651 122.998 104.22 118.633 101.211 118.633Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_2352)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M108.011 118.633H102.231C99.2222 118.633 96.7912 122.995 96.7912 128.377C96.7912 133.759 99.229 138.118 102.231 138.118H108.011C111.02 138.118 113.451 133.756 113.451 128.377C113.451 122.998 111.02 118.633 108.011 118.633Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M148.033 120.72L46.818 120.649V55.998H148.033V120.72Z",
    fill: "#C91761"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.033 55.998H79.4342V120.717H148.033V55.998Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.4342 55.998H46.818V121.995H79.4342V55.998Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 59.0036H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 61.8018H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 64.5966H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 67.3914H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 70.1896H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 72.9844H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 75.7792H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 78.574H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 81.3722H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 84.167H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 86.9618H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 89.76H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 92.5548H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 95.3496H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 98.1444H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 100.943H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 103.737H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 106.532H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 109.33H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 112.125H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 114.92H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.0628 117.718H148.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2438 119.904H22.8956C20.1076 119.904 17.85 123.944 17.85 128.928C17.85 133.912 20.1076 137.948 22.8956 137.948H28.2438C31.0318 137.948 33.2894 133.909 33.2894 128.928C33.2894 123.947 31.0318 119.904 28.2438 119.904Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.0472 119.904H29.6956C26.9076 119.904 24.65 123.944 24.65 128.928C24.65 133.912 26.9076 137.948 29.6956 137.948H35.0472C37.8318 137.948 40.0928 133.909 40.0928 128.928C40.0928 123.947 37.8318 119.904 35.0472 119.904Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2688 102.282H22.7392C22.2428 102.299 21.8348 101.769 21.8246 101.096C21.8178 101.026 21.8178 100.955 21.8246 100.885L22.5046 93.245C22.5896 92.4596 23.0758 91.885 23.6606 91.8476H26.214C26.707 91.8476 27.115 92.3678 27.1252 93.041C27.1252 93.109 27.1252 93.177 27.1252 93.245L26.4452 100.885C26.3432 101.66 25.84 102.262 25.2688 102.282Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7984 77.0474L22.9194 103.36L76.0376 124.168L75.667 72.3112L63.9846 71.9712H31.9838C30.0594 71.9542 28.3628 74.0214 27.7984 77.0474Z",
    fill: "#C91761"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M67.32 81.2804C65.3378 81.192 63.5596 82.8172 62.9782 85.2414L58.9594 102.078H51.2244L50.8028 124.29H76.245",
    fill: "#C91761"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.56 100.664C27.7814 100.664 27.1524 99.6642 27.1524 98.4334C27.1521 98.2189 27.1726 98.0048 27.2136 97.7942L30.1342 82.3446C30.379 81.0628 31.127 80.1856 31.9736 80.189H59.9148C60.2174 80.189 60.4656 80.5766 60.4656 81.0594C60.4663 81.145 60.4583 81.2304 60.4418 81.3144C59.8298 84.4968 57.8408 95.0402 57.0792 99.0726C56.9024 100.018 56.3516 100.664 55.7192 100.664H28.56Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2708 107.511C54.2703 107.782 54.251 108.053 54.213 108.321L54.0668 109.317L53.9818 109.905L53.3562 114.203L52.3362 121.19L52.054 123.131H12.5154V121.19L12.5426 114.203L12.58 110.024V108.324C12.24 106.08 13.3246 103.904 14.977 103.452C15.1709 103.399 15.371 103.373 15.572 103.374H51.2244C52.9074 103.36 54.2708 105.223 54.2708 107.511Z",
    fill: "#C91761"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3682 82.28V98.8414C74.3682 99.8444 73.8548 100.66 73.219 100.664H63.5562C62.9204 100.664 62.407 99.8478 62.407 98.8414C62.4068 98.6773 62.4204 98.5136 62.4478 98.3518L65.4262 81.4198C65.569 80.6072 66.045 80.0598 66.5754 80.0904L73.2598 80.4576C73.8786 80.495 74.3682 81.3008 74.3682 82.28Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.8596 80.189H39.5216L33.3914 100.664H38.7328L44.8596 80.189Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.0144 80.189H46.4644L40.3376 100.664H42.8842L49.0144 80.189Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M64.515 114.203V121.19H12.5222L12.5494 114.203H64.515Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M57.273 114.203H52.4654L43.8192 119.282V121.19H64.515V114.203H57.273Z",
    fill: "#FFCE51"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4846 119.282V121.19H12.5222L12.5494 114.203H12.8418L21.4846 119.282Z",
    fill: "#FFCE51"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.0614 124.29L75.667 72.3112L68.527 71.9712C66.7454 71.8828 64.6884 73.9534 64.1682 76.3538L58.9934 103.36H56.9772C54.7128 103.36 53.1624 105.009 53.1658 106.76L53.1964 124.297H76.0614",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1382 109.562C54.1375 109.626 54.1232 109.69 54.0962 109.748C54.0693 109.807 54.0303 109.859 53.9818 109.902C53.8987 109.979 53.7892 110.021 53.6758 110.021H12.58V109.096H53.686C53.7643 109.096 53.8412 109.116 53.9096 109.154C53.978 109.192 54.0356 109.247 54.077 109.313C54.12 109.389 54.1412 109.475 54.1382 109.562Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8288 109.099V110.024H12.5664L12.5698 109.099H19.8288Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1382 109.562C54.1375 109.626 54.1232 109.69 54.0963 109.748C54.0693 109.807 54.0303 109.859 53.9818 109.902C53.8987 109.979 53.7893 110.021 53.6758 110.021H43.707V109.096H53.6758C53.7541 109.096 53.831 109.116 53.8994 109.154C53.9678 109.192 54.0254 109.247 54.0668 109.313C54.1134 109.388 54.1381 109.474 54.1382 109.562Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M149.848 122.4V122.584C149.848 123.034 149.669 123.467 149.35 123.786C149.031 124.104 148.599 124.284 148.148 124.284H13.1002C12.6493 124.284 12.2169 124.104 11.8981 123.786C11.5793 123.467 11.4002 123.034 11.4002 122.584V122.4C11.4002 121.949 11.5793 121.517 11.8981 121.198C12.2169 120.879 12.6493 120.7 13.1002 120.7H148.148C148.599 120.7 149.031 120.879 149.35 121.198C149.669 121.517 149.848 121.949 149.848 122.4Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0474 122.097H22.9194V123.08H43.0474V122.097Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5644 122.587C17.5644 122.698 17.5316 122.806 17.4701 122.898C17.4086 122.99 17.3212 123.062 17.2189 123.105C17.1166 123.148 17.0039 123.159 16.8952 123.137C16.7865 123.116 16.6865 123.063 16.6079 122.985C16.5293 122.907 16.4756 122.807 16.4536 122.699C16.4316 122.59 16.4422 122.477 16.4841 122.375C16.5261 122.272 16.5975 122.184 16.6893 122.122C16.7811 122.06 16.8892 122.027 17 122.026C17.074 122.026 17.1473 122.04 17.2157 122.068C17.2842 122.096 17.3464 122.137 17.3989 122.189C17.4514 122.241 17.493 122.303 17.5214 122.372C17.5498 122.44 17.5644 122.513 17.5644 122.587Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M47.855 122.587C47.855 122.698 47.8221 122.806 47.7605 122.899C47.6988 122.991 47.6112 123.063 47.5087 123.105C47.4062 123.148 47.2934 123.159 47.1846 123.137C47.0758 123.116 46.9758 123.062 46.8973 122.984C46.8189 122.905 46.7655 122.805 46.7438 122.696C46.7222 122.588 46.7333 122.475 46.7757 122.372C46.8182 122.27 46.8901 122.182 46.9824 122.121C47.0746 122.059 47.1831 122.026 47.294 122.026C47.3677 122.026 47.4407 122.041 47.5087 122.069C47.5768 122.097 47.6386 122.138 47.6907 122.19C47.7428 122.242 47.7841 122.304 47.8123 122.372C47.8405 122.44 47.855 122.513 47.855 122.587Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1206 128.156C64.1206 122.747 66.572 118.361 69.598 118.361H63.7874C60.7648 118.361 58.3134 122.747 58.3134 128.156C58.3134 133.566 60.7648 137.948 63.7874 137.948H69.598C66.572 137.958 64.1206 133.576 64.1206 128.156Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.1206 128.156C64.1206 122.747 66.572 118.361 69.598 118.361H63.7874C60.7648 118.361 58.3134 122.747 58.3134 128.156C58.3134 133.566 60.7648 137.948 63.7874 137.948H69.598C66.572 137.958 64.1206 133.576 64.1206 128.156Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M69.598 137.962C72.6231 137.962 75.0754 133.576 75.0754 128.166C75.0754 122.757 72.6231 118.371 69.598 118.371C66.5729 118.371 64.1206 122.757 64.1206 128.166C64.1206 133.576 66.5729 137.962 69.598 137.962Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0366 135.803C72.181 135.803 73.9194 132.384 73.9194 128.166C73.9194 123.949 72.181 120.53 70.0366 120.53C67.8922 120.53 66.1538 123.949 66.1538 128.166C66.1538 132.384 67.8922 135.803 70.0366 135.803Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M69.683 134.776C71.7354 134.776 73.3992 131.817 73.3992 128.166C73.3992 124.516 71.7354 121.557 69.683 121.557C67.6306 121.557 65.9668 124.516 65.9668 128.166C65.9668 131.817 67.6306 134.776 69.683 134.776Z",
    fill: "#263238"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M68.867 132.991C70.3655 132.991 71.5802 130.831 71.5802 128.166C71.5802 125.502 70.3655 123.342 68.867 123.342C67.3685 123.342 66.1538 125.502 66.1538 128.166C66.1538 130.831 67.3685 132.991 68.867 132.991Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149.848 122.4V122.584C149.848 123.034 149.669 123.467 149.35 123.786C149.031 124.104 148.599 124.284 148.148 124.284H79.4342V120.7H148.148C148.599 120.7 149.031 120.879 149.35 121.198C149.669 121.517 149.848 121.949 149.848 122.4Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M128.493 128.156C128.493 122.747 130.944 118.361 133.967 118.361H128.16C125.134 118.361 122.682 122.747 122.682 128.156C122.682 133.566 125.134 137.948 128.16 137.948H133.96C130.944 137.958 128.493 133.576 128.493 128.156Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.493 128.156C128.493 122.747 130.944 118.361 133.967 118.361H128.16C125.134 118.361 122.682 122.747 122.682 128.156C122.682 133.566 125.134 137.948 128.16 137.948H133.96C130.944 137.958 128.493 133.576 128.493 128.156Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M133.967 137.962C136.992 137.962 139.444 133.576 139.444 128.166C139.444 122.757 136.992 118.371 133.967 118.371C130.942 118.371 128.489 122.757 128.489 128.166C128.489 133.576 130.942 137.962 133.967 137.962Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M134.409 135.803C136.553 135.803 138.292 132.384 138.292 128.166C138.292 123.949 136.553 120.53 134.409 120.53C132.264 120.53 130.526 123.949 130.526 128.166C130.526 132.384 132.264 135.803 134.409 135.803Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M134.052 134.776C136.104 134.776 137.768 131.817 137.768 128.166C137.768 124.516 136.104 121.557 134.052 121.557C131.999 121.557 130.336 124.516 130.336 128.166C130.336 131.817 131.999 134.776 134.052 134.776Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M133.236 132.991C134.734 132.991 135.949 130.831 135.949 128.166C135.949 125.502 134.734 123.342 133.236 123.342C131.737 123.342 130.523 125.502 130.523 128.166C130.523 130.831 131.737 132.991 133.236 132.991Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M111.812 80.24C111.744 81.549 111.625 82.8138 111.432 84.1024C111.264 85.4334 110.973 86.7458 110.561 88.0226C110.431 88.3945 110.269 88.754 110.075 89.097C109.94 89.3283 109.776 89.5409 109.585 89.7294L109.49 89.8178L109.436 89.8586L109.409 89.8824L109.293 89.9606L109.065 90.1204C108.488 90.4909 107.88 90.8128 107.25 91.0826C106.052 91.6088 104.808 92.0209 103.533 92.3134L103.091 91.103C104.173 90.5046 105.281 89.8926 106.291 89.2568C106.784 88.954 107.259 88.6213 107.712 88.2606L107.862 88.1348L107.936 88.0702C107.936 88.0702 107.967 88.0192 108.004 87.9376C108.104 87.7177 108.186 87.4903 108.249 87.2576C108.403 86.6984 108.524 86.1308 108.613 85.5576C108.718 84.966 108.803 84.3642 108.875 83.7522C109.014 82.5384 109.133 81.294 109.215 80.0836L111.812 80.24Z",
    fill: "#CE7A63"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M103.897 91.12L101.81 90.474L102.201 93.0002C102.201 93.0002 103.561 92.8302 104.241 92.0686L103.897 91.12Z",
    fill: "#CE7A63"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M99.28 92.0992L99.3956 92.4392C99.4608 92.627 99.5853 92.7885 99.7502 92.8995C99.9151 93.0104 100.112 93.0649 100.31 93.0546L101.374 93.007L100.98 90.474L99.8104 90.933C99.5885 91.0213 99.4094 91.192 99.3105 91.4094C99.2117 91.6267 99.2007 91.8739 99.28 92.0992Z",
    fill: "#CE7A63"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M114.281 77.7886C114.281 78.5774 113.9 80.1346 113.574 81.3042C113.332 82.144 113.132 82.7832 113.132 82.7832L112.652 82.6642L108.701 81.6646C108.64 79.6246 108.718 77.4044 110.741 76.0716C112.006 75.2352 114.271 76.3844 114.281 77.7886Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.277 77.9246C114.019 77.6526 113.434 77.605 112.159 78.0096C110.333 78.5876 109.823 80.5868 109.8 81.9434L112.652 82.6642L112.897 82.7288L113.132 82.7832C113.132 82.7832 113.23 82.4636 113.373 81.9774C113.431 81.7802 113.502 81.549 113.57 81.2974C113.911 80.1976 114.147 79.0684 114.277 77.9246Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M106.172 141.26L103.761 140.417L105.278 135.194L107.685 136.041L106.172 141.26Z",
    fill: "#CE7A63"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M138.38 135.072L136.418 136.534L132.403 132.464L134.365 131.002L138.38 135.072Z",
    fill: "#CE7A63"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M135.616 135.939L137.734 134.188C137.77 134.157 137.816 134.14 137.863 134.14C137.911 134.14 137.957 134.157 137.992 134.188L139.618 135.663C139.654 135.7 139.683 135.743 139.703 135.79C139.723 135.838 139.733 135.889 139.733 135.94C139.733 135.992 139.723 136.043 139.703 136.091C139.683 136.138 139.654 136.181 139.618 136.218L139.584 136.248C138.836 136.847 138.441 137.098 137.51 137.867C136.938 138.339 135.738 139.471 134.946 140.124C134.154 140.777 133.467 140.032 133.739 139.689C134.953 138.152 135.235 137.139 135.378 136.309C135.412 136.162 135.496 136.031 135.616 135.939Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M103.598 139.662L106.277 140.78C106.325 140.801 106.365 140.837 106.39 140.882C106.416 140.928 106.427 140.98 106.42 141.032L106.117 143.395C106.105 143.49 106.057 143.576 105.981 143.634C105.906 143.693 105.811 143.719 105.716 143.708C105.681 143.704 105.647 143.695 105.614 143.681C104.666 143.296 104.22 143.106 103.044 142.613L99.433 141.1C98.4538 140.689 98.6646 139.614 99.093 139.692C101.075 140.053 102.354 139.934 103.136 139.638C103.21 139.611 103.29 139.6 103.369 139.604C103.449 139.608 103.526 139.627 103.598 139.662Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.278 135.198L104.499 137.887L106.845 138.948L107.688 136.041L105.278 135.198Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.368 131.002L132.403 132.464L134.473 134.562L136.435 133.1L134.368 131.002Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M121.693 90.5522L111.765 90.695C110.405 83.0076 110.065 79.339 110.065 77.5744C110.063 77.1343 110.215 76.7074 110.494 76.3672C110.774 76.0271 111.163 75.7951 111.595 75.7112C112.2 75.5922 112.955 75.4562 113.713 75.3508C113.971 75.3168 114.233 75.2828 114.492 75.2556C115.991 75.127 117.498 75.1054 119 75.191C119.224 75.191 119.445 75.2114 119.68 75.225C120.7 75.2896 121.632 75.4188 122.295 75.5208C122.533 75.5592 122.746 75.6907 122.888 75.8865C123.03 76.0822 123.088 76.3261 123.049 76.5646C123.051 76.5816 123.051 76.5986 123.049 76.6156C122.757 77.9756 122.519 79.1826 122.329 80.257C122.026 81.957 121.836 83.3442 121.723 84.5546C121.553 86.5498 121.543 88.5554 121.693 90.5522Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.72 84.5648C121.22 83.0654 121.247 79.9544 121.785 78.948L122.332 80.2638C122.023 81.974 121.832 83.3544 121.72 84.5648Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M111.765 90.695C111.765 90.695 110.065 105.148 108.531 114.155C107.318 121.207 104.251 135.884 104.251 135.884L108.232 137.295C108.232 137.295 112.792 121.995 113.591 115.461C116.804 106.039 119.116 90.6236 119.116 90.6236L111.765 90.695Z",
    fill: "#C91761"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M103.605 136.87L108.212 138.492L108.827 137.013L103.829 135.102L103.605 136.87Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.797 94.9892L115.308 97.8418C114.764 99.9906 114.893 105.22 115.583 108.525C116.821 103.544 117.81 98.3008 118.425 94.7818L116.797 94.9892Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M113.92 90.695C113.92 90.695 115.699 106.872 119.02 115.855C120.686 120.36 133.045 133.715 133.045 133.715L135.833 131.485C135.833 131.485 127.996 118.011 124.569 114.485C123.172 106.665 124.93 94.9416 121.683 90.5556L113.92 90.695Z",
    fill: "#C91761"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.28 134.671L136.551 131.991L135.667 130.54L132.087 133.657L133.28 134.671Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M121.849 89.9708L122.308 90.8514C122.342 90.9194 122.264 90.9942 122.148 90.9942L111.731 91.1438C111.639 91.1438 111.568 91.0996 111.557 91.0452L111.459 90.1578C111.459 90.0966 111.53 90.0422 111.625 90.0422L121.683 89.896C121.714 89.8941 121.746 89.8999 121.775 89.9129C121.804 89.926 121.83 89.9458 121.849 89.9708Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M120.499 91.12H120.775C120.826 91.12 120.867 91.0894 120.863 91.0588L120.717 89.9028C120.717 89.8688 120.669 89.845 120.615 89.845H120.36C120.306 89.845 120.265 89.8756 120.272 89.9062L120.414 91.0588C120.397 91.086 120.448 91.12 120.499 91.12Z",
    fill: "#C91761"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M112.479 91.2288H112.751C112.805 91.2288 112.843 91.1982 112.839 91.1642L112.7 90.0116C112.7 89.9776 112.645 89.9504 112.591 89.9504H112.319C112.265 89.9504 112.224 89.981 112.227 90.015L112.37 91.1676C112.377 91.2016 112.424 91.2288 112.479 91.2288Z",
    fill: "#C91761"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M116.491 91.1642H116.763C116.817 91.1642 116.858 91.1336 116.855 91.0996L116.712 89.947C116.712 89.9096 116.661 89.8824 116.606 89.8858H116.334C116.28 89.8858 116.243 89.9164 116.243 89.9504L116.385 91.103C116.382 91.1438 116.436 91.1642 116.491 91.1642Z",
    fill: "#C91761"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4776 80.5188L113.213 78.4958L115.253 92.9628L100.783 94.9484L98.4776 80.5188Z",
    fill: "#C91761"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M98.4776 80.5188L113.213 78.4958L115.253 92.9628L100.783 94.9484L98.4776 80.5188Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.415 77.7972L109.481 78.3536L111.591 93.2785L115.526 92.722L113.415 77.7972Z",
    fill: "#C91761"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M117.392 91.1404L115.352 90.3414L115.552 92.8914C115.552 92.8914 116.912 92.8234 117.643 92.1128L117.392 91.1404Z",
    fill: "#CE7A63"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M123.808 78.4448C124.355 79.9748 124.828 81.5048 125.229 83.0688C125.433 83.8542 125.623 84.643 125.776 85.4488C125.851 85.8568 125.916 86.2716 125.963 86.7034C126.018 87.1545 126.037 87.6093 126.021 88.0634C126.011 88.3591 125.966 88.6526 125.885 88.9372C125.773 89.2872 125.586 89.6087 125.338 89.879C124.974 90.2685 124.542 90.5878 124.063 90.8208C123.278 91.2015 122.452 91.4901 121.601 91.681C120.01 92.05 118.388 92.2674 116.756 92.3304L116.596 91.0486C117.341 90.8718 118.102 90.6746 118.844 90.4672C119.585 90.2598 120.323 90.0286 121.03 89.7702C121.705 89.5381 122.357 89.2409 122.975 88.8828C123.199 88.7515 123.399 88.5824 123.566 88.383C123.61 88.315 123.61 88.298 123.604 88.298C123.61 88.1973 123.61 88.0962 123.604 87.9954C123.591 87.6659 123.555 87.3376 123.498 87.0128C123.444 86.6728 123.369 86.292 123.287 85.918C123.117 85.1904 122.927 84.4458 122.713 83.7012C122.288 82.2256 121.808 80.7262 121.329 79.2812L123.808 78.4448Z",
    fill: "#CE7A63"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M113.472 91.5994L113.631 92.191C113.679 92.381 113.788 92.5502 113.941 92.6729C114.094 92.7956 114.282 92.8651 114.478 92.871L115.573 92.9016L115.372 90.355L114.257 90.4808C114.139 90.4927 114.024 90.5278 113.919 90.5842C113.814 90.6406 113.722 90.7171 113.646 90.8093C113.571 90.9015 113.515 91.0076 113.481 91.1216C113.447 91.2356 113.436 91.3552 113.448 91.4736C113.453 91.516 113.461 91.5581 113.472 91.5994Z",
    fill: "#CE7A63"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M122.648 75.5956C123.791 76.0614 124.726 79.815 124.726 79.815L121.57 82.28C121.57 82.28 119.333 78.778 119.789 77.2582C120.176 75.973 121.193 75.0074 122.648 75.5956Z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M134.844 137H134.803C134.746 136.996 134.691 136.977 134.643 136.947C134.595 136.916 134.555 136.873 134.528 136.823C134.508 136.794 134.495 136.76 134.492 136.725C134.489 136.69 134.496 136.654 134.511 136.622C134.65 136.35 135.531 136.241 135.626 136.231C135.637 136.229 135.649 136.231 135.659 136.235C135.67 136.24 135.678 136.248 135.684 136.258C135.69 136.268 135.694 136.279 135.694 136.291C135.694 136.302 135.69 136.313 135.684 136.323C135.5 136.571 135.143 136.979 134.844 137ZM135.507 136.364C135.167 136.415 134.688 136.527 134.62 136.677C134.611 136.689 134.607 136.704 134.607 136.719C134.607 136.734 134.611 136.749 134.62 136.762C134.636 136.796 134.661 136.826 134.693 136.848C134.724 136.869 134.761 136.882 134.8 136.884C134.97 136.884 135.242 136.7 135.514 136.364H135.507Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M135.585 136.34C135.289 136.34 134.698 136.235 134.565 136C134.544 135.959 134.537 135.913 134.546 135.868C134.555 135.823 134.578 135.782 134.613 135.752C134.643 135.719 134.68 135.693 134.721 135.676C134.762 135.659 134.806 135.651 134.851 135.653C135.208 135.653 135.66 136.201 135.674 136.231C135.679 136.239 135.681 136.249 135.681 136.258C135.681 136.268 135.679 136.277 135.674 136.286C135.671 136.296 135.665 136.305 135.657 136.311C135.649 136.318 135.64 136.322 135.629 136.323L135.585 136.34ZM134.83 135.776C134.782 135.78 134.738 135.802 134.705 135.837C134.654 135.891 134.664 135.925 134.677 135.952C134.756 136.102 135.221 136.224 135.521 136.224C135.35 136.01 135.119 135.853 134.858 135.772L134.83 135.776Z",
    fill: "#263238"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M102.228 139.607C102.039 139.546 101.874 139.427 101.755 139.267C101.728 139.22 101.712 139.168 101.707 139.114C101.702 139.06 101.71 139.006 101.728 138.955C101.737 138.925 101.754 138.899 101.777 138.878C101.799 138.857 101.827 138.842 101.857 138.836C102.17 138.778 102.908 139.57 103.051 139.73C103.057 139.74 103.061 139.752 103.061 139.764C103.061 139.776 103.057 139.788 103.051 139.798C103.045 139.809 103.036 139.817 103.025 139.822C103.014 139.827 103.001 139.828 102.989 139.825C102.729 139.778 102.474 139.706 102.228 139.607ZM101.993 138.968C101.958 138.951 101.92 138.944 101.881 138.948C101.881 138.948 101.85 138.948 101.837 138.989C101.823 139.024 101.818 139.062 101.821 139.1C101.825 139.138 101.837 139.174 101.857 139.206C101.963 139.39 102.326 139.563 102.843 139.675C102.601 139.397 102.316 139.159 102 138.968H101.993Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M102.986 139.818H102.966C102.717 139.57 102.313 138.825 102.452 138.587C102.483 138.536 102.547 138.482 102.694 138.523C103.241 138.683 103.074 139.743 103.064 139.788C103.064 139.799 103.06 139.81 103.052 139.818C103.045 139.826 103.035 139.831 103.023 139.832C103.017 139.833 103.009 139.833 103.003 139.83C102.996 139.828 102.99 139.824 102.986 139.818ZM102.714 138.632H102.68C102.626 138.615 102.585 138.632 102.571 138.632C102.49 138.771 102.751 139.332 102.989 139.631C102.986 139.369 103.02 138.768 102.714 138.632Z",
    fill: "#263238"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M113.247 65.0182C113.247 65.0182 111.887 67.2928 112.907 68.289C113.927 69.2852 114.226 65.7526 114.226 65.7526L113.247 65.0182Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M119.564 70.3562C119.564 70.3562 121.264 67.6974 120.557 65.0556C119.85 62.4138 116.545 64.1206 115.151 63.3964C114.64 63.086 114.096 62.8339 113.529 62.645C113.438 62.618 113.342 62.6122 113.248 62.6281C113.155 62.644 113.066 62.6812 112.989 62.7368C112.649 63.036 113.24 63.597 113.424 63.8078C113.311 63.6772 113.181 63.5628 113.036 63.4678C112.856 63.3488 112.615 63.3386 112.696 63.6412C112.836 63.9663 113.087 64.2314 113.404 64.3892C113.271 64.3144 112.486 63.9166 112.431 64.1648C112.424 64.225 112.44 64.2856 112.475 64.3348C112.985 65.2868 114.012 66.4836 115.195 66.5074C116.62 66.5278 117.98 70.5364 119.564 70.3562Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M120.166 70.4752C120.078 71.3728 118.745 71.383 118.745 71.383C118.527 71.8967 118.164 72.3361 117.701 72.6478C117.66 73.1899 117.678 73.7349 117.756 74.273C117.98 75.1196 118.266 75.412 118.623 75.6024L118.337 75.8846C117.79 76.2 117.173 76.3719 116.542 76.3844L116.168 76.1668L115.678 76.245C114.318 75.7996 114.658 74.885 114.658 74.885C114.906 74.2639 114.92 73.5738 114.696 72.9436C113.39 72.5356 112.856 71.4 112.673 69.4892C112.489 67.5784 113.563 65.7492 113.563 65.7492C115.039 67.1738 117.963 66.2592 117.963 66.2592C117.837 68.9384 119.088 69.9278 119.088 69.9278C119.5 69.5606 120.251 69.581 120.166 70.4752Z",
    fill: "#CE7A63"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M115.42 70.72C115.771 70.6218 116.074 70.3995 116.273 70.0944C116.289 70.0703 116.295 70.0409 116.29 70.0124C116.285 69.9839 116.269 69.9585 116.246 69.9414C116.234 69.9328 116.221 69.9266 116.207 69.9232C116.193 69.9197 116.179 69.9191 116.165 69.9213C116.15 69.9235 116.137 69.9286 116.124 69.9361C116.112 69.9436 116.101 69.9535 116.093 69.9652C115.978 70.1714 115.8 70.3355 115.586 70.4334C115.371 70.5313 115.131 70.5579 114.9 70.5092C114.872 70.5007 114.842 70.5034 114.817 70.5168C114.791 70.5302 114.772 70.5531 114.764 70.5806C114.755 70.6086 114.758 70.6388 114.771 70.6648C114.784 70.6909 114.807 70.7107 114.835 70.72C115.027 70.7701 115.228 70.7701 115.42 70.72Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M115.807 68.3808C115.807 68.5542 115.739 68.7038 115.624 68.7208C115.508 68.7378 115.403 68.595 115.389 68.4216C115.376 68.2482 115.461 68.0816 115.576 68.0816C115.692 68.0816 115.794 68.204 115.807 68.3808Z",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M113.727 68.2924C113.727 68.4658 113.659 68.6154 113.543 68.6324C113.427 68.6494 113.325 68.5066 113.312 68.3332C113.298 68.1598 113.38 68.0102 113.495 67.9932C113.611 67.9762 113.716 68.1156 113.727 68.2924Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M114.277 69.9754L114.254 68.7174L113.628 69.7782C113.714 69.8577 113.818 69.9168 113.93 69.9509C114.043 69.9851 114.161 69.9934 114.277 69.9754Z",
    fill: "#BA4D3C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M116.756 67.32C116.771 67.316 116.785 67.309 116.797 67.2996C116.813 67.2898 116.828 67.2768 116.839 67.2613C116.851 67.2458 116.859 67.2282 116.863 67.2095C116.868 67.1907 116.868 67.1713 116.865 67.1523C116.862 67.1333 116.855 67.1152 116.844 67.099C116.731 66.9092 116.567 66.7551 116.37 66.6541C116.174 66.5531 115.953 66.5093 115.733 66.5278C115.713 66.5299 115.695 66.5358 115.678 66.5452C115.661 66.5546 115.647 66.5673 115.635 66.5826C115.623 66.5978 115.615 66.6153 115.61 66.6339C115.605 66.6526 115.604 66.672 115.607 66.691C115.612 66.7293 115.632 66.764 115.662 66.7875C115.693 66.8111 115.732 66.8216 115.77 66.8168C115.934 66.8066 116.098 66.8417 116.244 66.9185C116.39 66.9953 116.512 67.1106 116.596 67.252C116.612 67.2789 116.636 67.3001 116.665 67.3123C116.694 67.3245 116.726 67.3272 116.756 67.32Z",
    fill: "#263238"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M113.067 67.1806C113.105 67.1706 113.138 67.1463 113.159 67.1126C113.22 67.0204 113.306 66.9479 113.408 66.9038C113.509 66.8597 113.621 66.8461 113.73 66.8644C113.749 66.8683 113.768 66.8684 113.787 66.8647C113.806 66.861 113.824 66.8535 113.84 66.8427C113.855 66.8319 113.869 66.818 113.879 66.8019C113.89 66.7858 113.897 66.7677 113.9 66.7488C113.907 66.711 113.899 66.6719 113.877 66.6401C113.855 66.6082 113.822 66.5862 113.784 66.5788C113.616 66.5476 113.442 66.5679 113.286 66.6371C113.129 66.7062 112.997 66.821 112.907 66.9664C112.888 67 112.883 67.0396 112.892 67.0769C112.902 67.1143 112.925 67.1466 112.958 67.167C112.992 67.1848 113.03 67.1897 113.067 67.1806Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M119.177 75.7214L118.446 76.4354L117.144 77.7138L116.654 76.9352L116.168 76.1668L117.868 74.1404L119.105 75.6364L119.177 75.7214Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M116.168 76.1668L115.79 76.7958L115.236 77.7138L113.965 75.4188L114.777 74.4634L116.168 76.1668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c10e33a421bc1c54caed44f03e6a36ab.svg";
export { ForwardRef as ReactComponent };